import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import TagsService from 'services/TagsService.service';

const TagSearch = ({ onAddTag }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    page: 0,
    size: 200,
    name: ''
  });
  const [showTagSuggestions, setShowTagSuggestions] = useState(false);
  const [filteredTags, setFilteredTags] = useState([]);
  const inputRef = useRef(null);

  // Handle outside click to close the suggestions
  useEffect(() => {
    const handleClickOutside = event => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setShowTagSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFilters({ ...filters, name: searchTerm });
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchTerm]);

  useEffect(() => {
    if (filters.name.trim()) {
      searchTags();
    }
  }, [filters.name]);

  const searchTags = async () => {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await TagsService.list(queryParams);
    setFilteredTags(response.content || []);
  };

  const handleInputChange = e => {
    setSearchTerm(e.target.value);
  };

  const handleTagSelect = tag => {
    onAddTag(tag);
    setSearchTerm('');
    setShowTagSuggestions(false);
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  const handleAddTag = () => {
    if (searchTerm.trim()) {
      onAddTag(searchTerm.trim());
      setSearchTerm('');
    }
  };

  return (
    <div className="position-relative" ref={inputRef} style={{ width: '100%' }}>
      <InputGroup>
        <Form.Control
          type="text"
          placeholder="Pesquisar ou adicionar tags"
          value={searchTerm}
          onChange={handleInputChange}
          onFocus={() => setShowTagSuggestions(true)}
          onKeyDown={handleKeyPress}
        />
        <Button
          className="border-300 hover-border-secondary"
          variant="outline-secondary"
          onClick={handleAddTag}
        >
          <FontAwesomeIcon size="sm" icon={faPlus} />
        </Button>
      </InputGroup>

      {showTagSuggestions && filteredTags.length > 0 && (
        <ul
          className="px-0 list-tags bg-100 shadow rounded position-absolute w-100 mt-1 z-3"
          style={{ height: 'auto', maxHeight: 200, overflowY: 'auto' }}
        >
          {filteredTags.map((tag, index) => (
            <li
              key={index}
              style={{ listStyleType: 'none', cursor: 'pointer' }}
              className="px-3 py-2 bg-primary-hover item-list-hover"
              data-value={tag.id}
              onClick={() => handleTagSelect(tag.name)}
            >
              {tag.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TagSearch;
